import { CONTACTS } from 'constants/Entities';
import BASE_CONFIG from 'containers/contacts/TableConfig';
import { getMarketingStatusColumn } from 'components/TableCells/MarketingStatusCell/helpers';
import { setMarketingConsentContact } from 'services/MarketingConsentService';

const ALLOWED_COLS = ['nombre', 'apellidos', 'empresa', 'email'];
const PINNED_QUICK_FILTERS = ['marketingStatus', 'OnlySelectedType'];
const READ_ONLY_PINNED_FILTERS = ['marketingStatus'];

export default ({ onClickCheckbox, selectionToken, marketingCampaignsEnabled, canEdit } = {}) => {
    const tableParams = {
        ...(onClickCheckbox ? { contact: { onClickCheckbox } } : {}),
        marketingCampaignsEnabled,
        ...(canEdit !== undefined ? { canEdit } : {}),
    };
    const base = BASE_CONFIG(tableParams);

    const marketingColumn = getMarketingStatusColumn({
        minWidth: 160,
        entity: CONTACTS,
        setMarketingConsent: setMarketingConsentContact,
        isReadOnly: true,
    });

    return {
        ...base,
        useFiltersDrawer: false,
        useViewsInFilters: false,
        useViewsInMenu: false,
        filterKey: 'recipientsContacts',
        quickFilters: [...PINNED_QUICK_FILTERS],
        defaultFilters: [...PINNED_QUICK_FILTERS],
        readOnlyFilters: READ_ONLY_PINNED_FILTERS,
        readOnlyQuickFilters: READ_ONLY_PINNED_FILTERS,
        dontIgnoreTheseFilters: ['OnlySelectedType'],
        columnSelectorSections: undefined,
        withEntitySelection: true,
        selectionFor: 'marketingCampaigns',
        selectionEntity: 'contacts',
        selectionToken,
        isLocalSelection: false,
        columnDefs: [
            ...base.columnDefs
                .filter((col) => ALLOWED_COLS.includes(col.colId))
                .map(({ width, suppressSizeToFit, ...col }) => ({ ...col, minWidth: width })),
            marketingColumn,
        ],
    };
};
